import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { Redirect } from 'react-router-dom';
import { Trad } from '../components/';

export class ErroreAccesso extends React.Component<Glob.IRouteGlobaleProps, {}>{
    public render() {
        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon ">
                            <i className="fa fa-exclamation-triangle"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Errore")}
                        </h3>
                    </div>
                </div>
            </div>
            <div className="kt-portlet__body">
                <div>
                    <div className="swal2-icon swal2-error swal2-animate-error-icon" style={{ display: "flex" }}>
                        <span className="swal2-x-mark">
                            <span className="swal2-x-mark-line-left"></span>
                            <span className="swal2-x-mark-line-right"></span>
                        </span>
                    </div>
                    <h3 style={{textAlign: "center"}}>
                        {Trad.Trad("Non hai i permessi per accedere alla pagina")}
                    </h3>
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/form/ErroreAccesso.tsx